export const PreAlertaVendemosContigo=[
    {
        Header: "preAlerta",
        accessor: "id_preAlerta"
      },
    {

        Header: "No. de Guía",
        accessor: "guias"
      },
      
      {
        Header: "Descripcion de las guias",
        accessor: "descripcion"
      },
      {
        Header: "Destinatario",
        accessor: "Nombre_destinatario"
      },
      {
        Header: "Tipo de preparacion",
        accessor: "Tipo_preparacion"
      },
      {
        Header: "Descripcion envio",
        accessor: "Descripcion_producto"
      },
      {
        Header: "Direccion destinatario",
        accessor: "Direccion_destinatario"
      },
      {
        Header: "telefono",
        accessor: "telefono"
      }
]

export const PreAlertaVendemosContigoInicial={
    guias:"-",
    id_preAlerta:0,
    Descripcion:"",
    Nombre_destinatario:"",
    Tipo_preparacion:"",
    Descripcion_producto:"",
    Direccion_destinatario:"",
    telefono:""
  }